/**
 * Global loading bar + progressive image blur-up.
 * Dispatches: theme:loading:start | theme:loading:end
 */
(function () {
  let pending = 0;
  let barEl;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animationsOn() {
    if (window.theme && window.theme.animationsEnable === false) return false;
    return true;
  }

  function loadingBarOn() {
    if (!animationsOn()) return false;
    if (window.theme && window.theme.animationsLoadingBar === false) return false;
    return true;
  }

  function blurUpOn() {
    if (!animationsOn()) return false;
    if (window.theme && window.theme.animationsBlurUp === false) return false;
    return true;
  }

  function getBar() {
    if (!barEl) barEl = document.querySelector('.theme-loading-bar');
    return barEl;
  }

  function start() {
    if (prefersReducedMotion() || !loadingBarOn()) return;
    const bar = getBar();
    if (!bar) return;
    pending += 1;
    bar.hidden = false;
    bar.classList.add('is-visible');
    bar.classList.remove('is-finished');
    if (pending === 1) bar.style.width = '40%';
  }

  function end() {
    if (pending <= 0) return;
    pending = Math.max(0, pending - 1);
    if (pending > 0) return;
    if (prefersReducedMotion() || !loadingBarOn()) return;
    const bar = getBar();
    if (!bar) return;
    bar.style.width = '100%';
    bar.classList.add('is-finished');
  }

  function onBarTransitionEnd(event) {
    if (event.propertyName !== 'width') return;
    const bar = getBar();
    if (!bar || !bar.classList.contains('is-finished')) return;
    bar.classList.remove('is-visible', 'is-finished');
    bar.style.width = '0';
    bar.hidden = true;
  }

  function markBlurImageLoaded(img) {
    if (!img || img.classList.contains('is-loaded')) return;
    img.classList.add('is-loaded');
    const wrap = img.closest('.theme-blur-up');
    if (wrap) wrap.classList.add('is-loaded');
  }

  function initBlurImages(root) {
    if (!blurUpOn()) return;
    const scope = root && root.nodeType === 1 ? root : document;
    scope.querySelectorAll('.theme-blur-up__img:not(.is-loaded)').forEach((img) => {
      if (img.complete && img.naturalWidth > 0) markBlurImageLoaded(img);
    });
  }

  function onImageLoad(event) {
    const img = event.target;
    if (!img.matches('.theme-blur-up__img')) return;
    markBlurImageLoaded(img);
  }

  document.addEventListener('theme:loading:start', start);
  document.addEventListener('theme:loading:end', end);

  window.themeLoading = {
    start,
    end,
    initBlurImages,
  };

  document.addEventListener('DOMContentLoaded', () => {
    getBar()?.addEventListener('transitionend', onBarTransitionEnd);
    initBlurImages(document);
  });

  document.addEventListener('load', onImageLoad, true);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.nodeType === 1) {
      initBlurImages(event.target);
      if (typeof window.themeScrollRevealInit === 'function') {
        window.themeScrollRevealInit(event.target);
      }
    }
  });
})();
